import React from "react";
import styled from "styled-components";

const LoadMoreButton = styled.button`
  border: 1px solid var(--color-black);
  margin: 1rem auto;
  padding: 0.875rem;
  min-width: 225px;
  background-color: transparent;
  cursor: pointer;
  font-size: 1rem;
  transition: all 0.5s ease;
  &:hover {
    background-color: var(--color-primary);
    color: var(--color-white);
    border: 1px solid var(--color-primary);
  }
`;

export function usePaginatedList(
  list,
  limit,
  filter = () => true,
  filterArg = undefined
) {
  const [filterArgument, setFilterArg] = React.useState(filterArg);
  const [newList, setNewList] = React.useState(
    list.filter((item) => filter(item, filterArgument)).slice(0, limit)
  );

  return [
    newList,
    ({ children }) =>
      newList.length >=
      list.filter((item) => filter(item, filterArgument)).length ? null : (
        <LoadMoreButton
          onClick={() =>
            setNewList(
              list
                .filter((item) => filter(item, filterArgument))
                .slice(0, newList.length + limit)
            )
          }
        >
          {children}
        </LoadMoreButton>
      ),
    (newFilterArg) => {
      setFilterArg(newFilterArg);
      setNewList(
        list.filter((item) => filter(item, newFilterArg)).slice(0, limit)
      );
    },
  ];
}
